import clsx from 'clsx';
import useUserAccount from '../../../hooks/userAccountHook';
import { User } from '../../../models/User';
import { ITeamAdminMetrics } from '../../../models/generalMetrics/IGeneralMetrics';
import BarChart from './BarChart';
import { FaChartLine } from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons';
import TabNav, { ITab } from '../../tabs/TabNav';
import { useState } from 'react';
import TabContent from '../../tabs/TabContent';

const TeamsSalesBarChart = (props: { teamMetrics: ITeamAdminMetrics }) => {
  const { user } = useUserAccount();
  const [activeTab, setActiveTab] = useState('income');

  const chartData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug',
      'Sept',
      'Oct',
      'Nov',
      'Dec'],
    datasets: [
      {
        label: '',
        data: {
          Jan: props.teamMetrics['mom']?.sales?.JANUARY,
          Feb: props.teamMetrics['mom']?.sales?.FEBRUARY,
          Mar: props.teamMetrics['mom']?.sales?.MARCH,
          Apr: props.teamMetrics['mom']?.sales?.APRIL,
          May: props.teamMetrics['mom']?.sales?.MAY,
          Jun: props.teamMetrics['mom']?.sales?.JUNE,
          Jul: props.teamMetrics['mom']?.sales?.JULY,
          Aug: props.teamMetrics['mom']?.sales?.AUGUST,
          Sept: props.teamMetrics['mom']?.sales?.SEPTEMBER,
          Oct: props.teamMetrics['mom']?.sales?.OCTOBER,
          Nov: props.teamMetrics['mom']?.sales?.NOVEMBER,
          Dec: props.teamMetrics['mom']?.sales?.DECEMBER
        },
        borderColor: '',
        backgroundColor: '#FBC02D',
        tension: 0.2,
        fill: true,
        pointColor: '#FBC02D'
      }
    ]
  };

  const chartPoliciesData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug',
      'Sept',
      'Oct',
      'Nov',
      'Dec'],
    datasets: [
      {
        label: '',
        data: {
          Jan: props.teamMetrics['mom']?.count?.JANUARY,
          Feb: props.teamMetrics['mom']?.count?.FEBRUARY,
          Mar: props.teamMetrics['mom']?.count?.MARCH,
          Apr: props.teamMetrics['mom']?.count?.APRIL,
          May: props.teamMetrics['mom']?.count?.MAY,
          Jun: props.teamMetrics['mom']?.count?.JUNE,
          Jul: props.teamMetrics['mom']?.count?.JULY,
          Aug: props.teamMetrics['mom']?.count?.AUGUST,
          Sept: props.teamMetrics['mom']?.count?.SEPTEMBER,
          Oct: props.teamMetrics['mom']?.count?.OCTOBER,
          Nov: props.teamMetrics['mom']?.count?.NOVEMBER,
          Dec: props.teamMetrics['mom']?.count?.DECEMBER
        },
        borderColor: '',
        backgroundColor: '#FBC02D',
        tension: 0.2,
        fill: true,
        pointColor: '#FBC02D'
      }
    ]
  };

  const getTabs = () => {
    let tabs: ITab[] = [
      {
        id: 'income',
        title: 'Monthly income'
        // itemCount: customer && customer?.policyList && customer?.policyList?.length
      },
      {
        id: 'total',
        title: 'Policies'
        // itemCount: customer && customer?.tasks && customer?.tasks?.length
      }
    ];

    return tabs;
  };


  return (
    <div className="flex flex-col lg:flex-row gap-5">
      <div className="w-full  lg:w-[70%]">
        <div className=" border border-[#E4E4E4] rounded-md bg-white">
          <div className="flex items-end justify-between px-5 pt-7">
            <div className="">
              <h2 className="font-semibold text-black text-2xl">YTD GHS {props.teamMetrics.sales?.this_year?.toFixed(2)}</h2>
            </div>
            <div className="w-fit px-3">
              <TabNav
                tabs={getTabs()}
                activeTab={activeTab}
                setActiveTab={(id: string) => {
                  setActiveTab(id);
                }}
                classes='px-[5px] py-[5px]'
              />
            </div>
          </div>

          <hr />

          <div className=" overflow-hidden md:px-4">
            <div
              className={clsx(
                'py-1 sm:py-18 my-0 overflow-hidden p-1 sm:p-12 md:px-4 flex justify-end flex-col w-full   rounded',
                { ['!w-full']: !(user.isOwner() || user.isSupervisor()) }
              )}>
              <div className='text-center'>
                <TabContent id={'income'} activeTab={activeTab}>
                  <span className="text-sm font-semibold text-center">Monthly {user.isRideSharing() ? "Income" : "Policy Sales"}</span>
                  <BarChart data={chartData} isInsurer={true} />
                </TabContent>
              </div>
              <div className='text-center'>
                <TabContent id={'total'} activeTab={activeTab}>
                  <span className="text-sm font-semibold text-center">Monthly Policies Issued</span>
                  <BarChart data={chartPoliciesData} isInsurer={true} />
                </TabContent>
              </div>


            </div>
          </div>
        </div>
      </div>

      <div className="h-auto border border-[#E4E4E4] rounded w-full lg:w-[30%] grid grid-cols-1 items-center bg-white">
        <div className="mt-12"></div>
        <hr className="" />
        <div className="p-5 grid grid-cols-2 items-center justify-start">
          <span className="text-gray-500">Today</span>
          <span className="text-[18px] ">{props.teamMetrics.sales?.today?.toFixed(2)}</span>
        </div>
        <hr />

        <div className="p-5 grid grid-cols-2 items-center justify-start">
          <span className="text-gray-500">Week</span>
          <span className="text-[18px] ">{props.teamMetrics.sales?.this_week?.toFixed(2)}</span>
        </div>
        <hr />

        <div className="p-5 grid grid-cols-2 items-center justify-start">
          <span className="text-gray-500">Month</span>
          <span className="text-[18px] ">{props.teamMetrics.sales?.this_month?.toFixed(2)}</span>
        </div>
        <hr />

        <div className="p-5 grid grid-cols-2 items-center justify-start">
          <span className="text-gray-500">Quarterly Trend</span>
          <FaChartLine className='h-10 w-10 text-primary-main ' />
        </div>
        <hr />

        <div className="p-5 grid grid-cols-2 items-center justify-start">
          <span className="text-gray-500">Comp to last year</span>
          <span className="text-lg "><FontAwesomeIcon icon={faCaretUp} className='text-success-main' /> 100%</span>
        </div>
      </div>
    </div>
  );
};

export default TeamsSalesBarChart;
